import React from 'react';
// import React from 'react-native-elements';
import {useMutation} from "@apollo/client";
import {ASSIGN_WORKSHOP_AND_CGT} from "../query";
import {clientV2} from "../../../common";
import {View, Text} from "react-native";

interface IAssignWorkshopAndAdvisorMutationProps {
    children: ({
                   assignWorkshopAndAdvisorMutation
               }) => JSX.Element;
}

export const AssignWorkshopAndAdvisorMutation = (props: IAssignWorkshopAndAdvisorMutationProps) => {
    const [assignWorkshopAndAdvisorMutation, {data}] = useMutation(ASSIGN_WORKSHOP_AND_CGT, {client: clientV2});
    return props.children({assignWorkshopAndAdvisorMutation})
};